export const info = {
  modalId: "GIFT_CARD",
  storageKey: "GIFT_CARD_MODAL",
} as const;
